<template>
  <div class="sidebar-pinned">
    <Navbar />

    <main class="admin-main">
      <!--site header begins-->

      <section class="admin-content">

        <!-- ── Page Header ─────────────────────────────────────── -->
        <div class="page-header">
          <div class="container">
            <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
              <div class="header-icon-wrap">
                <i class="fe fe-shield" style="font-size: 22px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">{{ orgDetails.organization_name }}</h4>
                <small style="opacity: .8;">TPA dashboard overview</small>
              </div>
            </div>
          </div>
        </div>

        <div class="container mt-n3 pb-5">

          <!-- ── Summary Stat Cards ── -->
          <div class="row mb-1">
            <div class="col-lg-3 col-md-6">
              <router-link :to="{ path: '/view-clients-tpa' }" class="text-decoration-none">
                <div class="stat-card">
                  <div class="stat-icon-wrap" style="background: #e8f4ff;">
                    <i class="fe fe-users" style="color: #2563eb;"></i>
                  </div>
                  <div>
                    <p class="stat-label">Enrollees</p>
                    <h3 class="stat-value" v-if="clients != ''">{{ clients.meta.total | numeral(0, 0) }}</h3>
                  </div>
                </div>
              </router-link>
            </div>

            <div class="col-lg-3 col-md-6">
              <router-link :to="{ path: '/add-officers' }" class="text-decoration-none">
                <div class="stat-card">
                  <div class="stat-icon-wrap" style="background: #f3e5f5;">
                    <i class="fe fe-briefcase" style="color: #7c3aed;"></i>
                  </div>
                  <div>
                    <p class="stat-label">Staffs</p>
                    <h3 class="stat-value" v-if="employees != ''">{{ employees.meta.total }}</h3>
                  </div>
                </div>
              </router-link>
            </div>

            <div class="col-lg-3 col-md-6">
              <router-link :to="{ path: '/all-claims' }" class="text-decoration-none">
                <div class="stat-card">
                  <div class="stat-icon-wrap" style="background: #ecfdf5;">
                    <i class="mdi mdi-view-day" style="color: #059669;"></i>
                  </div>
                  <div>
                    <p class="stat-label">Claims</p>
                    <h3 class="stat-value">{{ claims.data.length }}</h3>
                  </div>
                </div>
              </router-link>
            </div>

            <div class="col-lg-3 col-md-6">
              <router-link :to="{ path: '/authorization-code' }" class="text-decoration-none">
                <div class="stat-card">
                  <div class="stat-icon-wrap" style="background: #fff7e6;">
                    <i class="fe fe-anchor" style="color: #d97706;"></i>
                  </div>
                  <div>
                    <p class="stat-label">Authorization Code</p>
                    <h3 class="stat-value">{{ codes.length }}</h3>
                  </div>
                </div>
              </router-link>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 mb-4">
              <TPAEnrollees/>
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-md-6">
              <div class="card shadow-sm mb-4">
                <div class="card-body">
                  <ClaimStatusChart/>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card shadow-sm mb-4">
                <div class="card-body">
                  <ReferralStatusChart/>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 mb-4">
              <div class="card table-card shadow">
                <div class="d-flex align-items-center justify-content-between px-4 pt-4 pb-3">
                  <div>
                    <h6 class="mb-0 font-weight-bold text-dark">
                      <i class="fe fe-users text-primary mr-2"></i> Employees
                    </h6>
                    <small class="text-muted" v-if="employees != ''">{{ employees.meta.total }} record(s)</small>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead class="table-head">
                      <tr>
                        <!-- <th>Picture</th> -->
                        <th class="table-th px-4">Name</th>
                        <th class="table-th">Phone Number</th>
                        <th class="table-th">Email</th>
                        <!-- <th>Beneficiaries Enrolled</th> -->
                        <!-- <th>Action</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="client in employees.data" v-bind:key="client.id" class="table-row">
                        <!-- <td>
                                <div class="avatar avatar-sm " v-if="client.agent.user_image != null ">
                                  <img :src="`https://claimify-api.hayokmedicare.ng/image/${client.agent.user_image}`"
                                    class="avatar-img avatar-sm rounded-circle"
                                            alt=""></div>
                            </td> -->
                        <td class="px-4 py-3">
                          <div class="d-flex align-items-center" style="gap: 10px;">
                            <div class="employee-avatar">
                              {{ (client.firstname || '?')[0].toUpperCase() }}
                            </div>
                            <p class="mb-0 font-weight-bold" style="font-size: .88rem;">
                              {{ client.firstname }} {{ client.lastname }}
                            </p>
                          </div>
                        </td>
                        <td class="py-3" style="font-size: .88rem;">{{ client.phone_number }}</td>
                        <td class="py-3" style="font-size: .88rem;">{{ client.email }}</td>
                        <!-- <td> {{client.enrolleduserby_count}} Enrollees</td> -->
                        <!-- <td>
                                  <button type="button" @click="deleteAgent(client)" class="btn btn-danger">delete  <i class="fe fe-delete"></i></button>
                              </td> -->
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </main>
  </div>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import Footer from "@/views/Footer.vue";
import TPAEnrollees from "./components/TPAEnrollees.vue";
import ClaimStatusChart from "./components/ClaimStatusChart.vue";
import ReferralStatusChart from "./components/ReferralStatusChart.vue";

export default {
  components: {
    Navbar,
    Footer, TPAEnrollees, ClaimStatusChart, ReferralStatusChart
  },

  data() {
    return {
      auth_user: "",
      clients: "",
      officers: "",
      orgDetails: "",
      codes: "",
      employees: "",
      claims: "",
      user: null,
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.axios
      .get(`/api/v1/auth/getOrgDetails/${this.user.id}`)
      .then((response) => {
        this.orgDetails = response.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  methods: {
    getOrgDetails() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/getOrgDetails/${this.user.id}`)
        .then((response) => {
          this.orgDetails = response.data;
          let org_id = response.data.id;

          // get clients
          this.axios
            .get(`/api/v1/auth/org_client/${org_id}`)
            .then((response) => {
              this.clients = response.data;
              console.log(response);
              // this.getEmployees()
            })
            .catch((error) => {
              console.error(error);
            });
          //end of get ss

          // get employees
          this.axios
            .get(`/api/v1/auth/enrollment_user/${org_id}`)
            .then((response) => {
              this.employees = response.data;
              console.log(response);
            })
            .catch((error) => {
              console.error(error);
            });
          // end of employees

          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getEmployees() {
      // get employees
      this.axios
        .get(`/api/v1/auth/enrollment_user/${this.orgDetails.id}`)
        .then((response) => {
          this.employees = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
      //end of employees
    },
    getClaims() {
      this.isLoading = true;
        this.axios
          .get(`/api/v1/auth/claim-org`, {
            params: {
              claim_status: 'All',
              claim_unique_id: this.claim_unique_id,
              authorization_code: this.authorization_code,
              id_card_number: this.id_card_number,
              provider_id: this.provider_id,
              date: this.date,
              from: this.from,
              to: this.addOneDay,
            },
          })
          .then((response) => {
            this.claims = response.data;
            console.log(response);
            this.isLoading = false;
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
          });
    },

     getCodesTpa() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/authorization_code-tpa`)
        .then((response) => {
          this.codes = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    deleteAgent(client) {
      if (confirm("Are you sure you want to delete?")) {
        this.axios
          .delete(`/api/v1/auth/enrollment_user/${client.id}`)
          .then((response) => {
            console.log(response);
            this.$toasted.info("Deleted Successfully", {
              position: "top-center",
              duration: 3000,
            });
          })
          .catch((error) => {
            console.error(error);
            this.$toasted.error("Error!", {
              position: "top-center",
              duration: 3000,
            });
          });
      }
    },
  },
  created() {
    this.getOrgDetails();
    this.getClaims();
    this.getCodesTpa();
  },
};
</script>
<style lang="css" scoped>
.spacer-top {
  margin-top: 10px;
}

/* Stat cards */
.stat-card {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;
}

.stat-icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  flex-shrink: 0;
}

.stat-label {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #94a3b8;
  margin-bottom: 2px;
  font-weight: 600;
}

.stat-value {
  font-size: 1.35rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0;
  line-height: 1.2;
}
</style>
